module.exports = __webpack_public_path__ + "img/CerealCityScienceLogo.07bb9a58.png";